/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface FileRefAttributeDTO
 */
export interface FileRefAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof FileRefAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof FileRefAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof FileRefAttributeDTO
     */
    mimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileRefAttributeDTO
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof FileRefAttributeDTO
     */
    sizeBytes?: number;
}



/**
 * Check if a given object implements the FileRefAttributeDTO interface.
 */
export function instanceOfFileRefAttributeDTO(value: object): value is FileRefAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function FileRefAttributeDTOFromJSON(json: any): FileRefAttributeDTO {
    return FileRefAttributeDTOFromJSONTyped(json, false);
}

export function FileRefAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileRefAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'path': json['path'] == null ? undefined : json['path'],
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
    };
}

export function FileRefAttributeDTOToJSON(value?: FileRefAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'mimeType': value['mimeType'],
        'path': value['path'],
        'sizeBytes': value['sizeBytes'],
    };
}

